import * as React from "react";
import { cn } from "@/lib/utils";
import { NavLink } from "react-router";
import { MainNavComponentItem } from "../ui/MainNavComponentItem";
import { IconYoutube } from "../ui/IconYoutube";
import { IconX } from "../ui/IconX";
import { WalletButton } from "../ui/wallet-button";
import env from "@/environments/config";

const Header = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"header">
>(({ className }, ref) => {
  const pattern: RegExp = /Mobile|webOS/;
  const userAgent = window.navigator.userAgent
  let isMobileView = pattern.test(userAgent)
  if (window.innerWidth < 640) {
    isMobileView = true;
  }

  const [data, setData] = React.useState({
    showMobileNav: isMobileView,
    showDesktopNav: !isMobileView
  });
  const [toggleMenu, setToggleMenu] = React.useState(false);

  function toggleMobileNav() {
    setToggleMenu(!toggleMenu);
  }

  function updateNav() {
    if (window.innerWidth < 640) {
      setData({ showMobileNav: true, showDesktopNav: false });
    } else {
      setData({ showMobileNav: false, showDesktopNav: true });
    }
  }

  React.useEffect(() => {
    window.addEventListener('resize', updateNav);

    return () => {
      window.removeEventListener('resize', updateNav);
    };
  }, []);

  const nftMintLink = "https://magiceden.us/launchpad/ethereum/think_agent_bundle";
  return (
    <header
      ref={ref}
      className={cn("Navigation w-full", className)}
      data-controller="navigation"
    >
      <div data-navigation-target="mobileNav" className={isMobileView ? '' : 'hidden'}>
        <div className="w-full h-2 Think-V2-Gradient"></div>
        {
          env.MINT_HEADER ?
          (

            <div className="w-gull py-2 text-center uppercase heading-display border-b-[1px] border-[#404040]">
              THINK GENESIS MINT <a className="underline" href={nftMintLink} target="_blank">NOW LIVE &#10132;</a>
            </div>
          ) : null
        }
        <div data-controller="dropdown">
          <div className="flex flex-row justify-between items-center p-4">
            <NavLink onClick={() => setToggleMenu(false)} to="/" className="hover:text-red transition">
              <img src="/images/logo-think-horiz.svg" className="w-auto h-8 sm:h-8 md:h-11" />
            </NavLink>
            <div className="mt-2 ">
              <WalletButton className="px-2 md:px-5 py-3 ring ring-1 ring-inset ring-teal hover:bg-gradient-to-b text-white " />
            </div>
            <button
              className="relative cursor-pointer group overflow-hidden mt-1 flex flex-row justify-center items-center transition-all"
              onClick={toggleMobileNav}
              id="user_dropdown_button"
              type="button">
              <div className="relative w-10 h-8">
                <span className="sr-only">Open main menu</span>
                <div className="absolute w-6 h-[2px] rounded-full bg-sand inset-1/2 -translate-x-1/2 translate-y-0"></div>
                <div className="absolute w-6 h-[2px] rounded-full bg-sand inset-1/2 -translate-x-1/2 translate-y-2"></div>
                <div className="absolute w-6 h-[2px] rounded-full bg-sand inset-1/2 -translate-x-1/2 -translate-y-2"></div>
              </div>
            </button>
          </div>

          {/* Mobile menu, show/hide based on menu open state. */}
          <div className={toggleMenu ? '' : 'hidden'} role="dialog" aria-modal="true"
            data-dropdown-target="menu"
            data-transition-enter-from="opacity-0 scale-95"
            data-transition-enter-to="opacity-100 scale-100"
            data-transition-leave-from="opacity-100 scale-100"
            data-transition-leave-to="opacity-0 scale-95">
            <div className="fixed inset-y-0 left-0 z-50 w-full h-2 Think-V2-Gradient"></div>
            <div className="fixed flex flex-col inset-y-0 left-0 z-50 w-full overflow-y-auto bg-black p-4 mt-2">
              <header className="flex items-center gap-x-6 w-full flex-row justify-between shrink-0 mb-6">

                <NavLink onClick={() => setToggleMenu(false)} to="/">
                  <img src="/images/logo-think-horiz.svg" className="w-auto h-8 sm:h-8 md:h-11" />
                </NavLink>
                <div className="mt-2 ">
                  <WalletButton className="px-2 md:px-5 py-3 ring ring-1 ring-inset ring-teal hover:bg-gradient-to-b text-white " />
                </div>
                <button
                  className="ml-1 mr-1 mt-1 relative cursor-pointer group overflow-hidden flex flex-row justify-center items-center bg-black transition-all"
                  onClick={toggleMobileNav}
                  id="user_dropdown_button"
                  type="button">
                  <div className="-m-2.5 p-2.5">
                    <span className="sr-only">Close menu</span>
                    <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </div>
                </button>
              </header>
              <div className="flex flex-col justify-between items-start flex-grow">
                <section className="st-accordion font-heading text-offWhite" data-controller="accordion">
                  <style>
                  </style>
                  <div className="flex flex-col gap-y-4 text-2xl">

                    <MainNavComponentItem onClick={() => setToggleMenu(false)} to="/about" title="Team">Team</MainNavComponentItem>
                    <MainNavComponentItem onClick={() => setToggleMenu(false)} to="/investors" title="Investors">Investors</MainNavComponentItem>
                    <MainNavComponentItem onClick={() => setToggleMenu(false)} to="/partners" title="Partners">Partners</MainNavComponentItem>
                    <MainNavComponentItem onClick={() => setToggleMenu(false)} to="https://docs.thinkagents.ai" target="_blank" title="Docs">Docs</MainNavComponentItem>
                    <MainNavComponentItem onClick={() => setToggleMenu(false)} to="/contact" title="Contact">Contact</MainNavComponentItem>
                    {/* <MainNavComponentItem to="/blog" title="News">News</MainNavComponentItem> */}
                    <MainNavComponentItem onClick={() => setToggleMenu(false)} to="/faq" title="FAQ">FAQ</MainNavComponentItem>
                  </div>
                </section>
                <footer className="shrink-0 space-y-3 mb-8 text-xs font-mono text-offWhite flex flex-col gap-y-1">
                  <NavLink to="/" onClick={() => setToggleMenu(false)} className="hover:text-red transition">
                    <img src="/images/brandmark-light-2.svg" className="w-auto h-8 sm:h-8 md:h-11" />
                  </NavLink>
                  <NavLink to="/privacy-policy" onClick={() => setToggleMenu(false)} title="Your Privacy" className="hover:text-teal transition">Your Privacy</NavLink>
                  <NavLink to="/terms-and-conditions" onClick={() => setToggleMenu(false)} title="Terms and Conditions" className="hover:text-teal transition">Terms and Conditions</NavLink>
                  <div className="flex flex-row gap-4 font-semibold text-xl md:mt-4 md:text-lg lg:text-xl mb-4 text-off-white">
                    <NavLink to="/privacy-policy" onClick={() => setToggleMenu(false)} title="Your Privacy" target="_blank" className="text-off-white hover:text-teal">
                      <IconX className="h-8" />
                    </NavLink>
                    <NavLink to="/privacy-policy" onClick={() => setToggleMenu(false)} title="Your Privacy" target="_blank" className="text-off-white hover:text-tealn">
                      <IconYoutube className="h-8" />
                    </NavLink>
                  </div>
                </footer>
                {/* I would like to replace with this, but i think it may be creating errors—z */}
                {/* <footer className="shrink-0 space-y-3 mb-8 text-xs font-mono text-offWhite flex flex-col gap-y-1">
                  <%= link_to root_path, class: "hover:text-red transition" do %>
                    <%= inline_svg "brandmark-light-2.svg", class: "w-auto w-auto h-8 sm:h-11" %>
                  <% end %>
                  <%= link_to "Your Privacy", privacy_policy_path, class: "hover:text-teal transition" %>
                  <%= link_to "Terms and Conditions", terms_and_conditions_path, class: "hover:text-teal transition" %>
                  <%= link_to "https://x.com/thinkagents", class: "text-off-white hover:text-teal", target: "_blank" do %>
                      <%= inline_svg "icons/icon-x.svg", class: "h-8" %>
                  <% end %> 
                  <%= link_to "https://www.youtube.com/@ThinkAgents", class: "text-off-white hover:text-teal", target: "_blank" do %>
                    <%= inline_svg "icons/icon-youtube.svg", class: "h-8" %>
                  <% end %>
                </footer> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-navigation-target="desktopNav" className={isMobileView ? 'hidden' : ''}>
        <div className="w-full h-2 Think-V2-Gradient"></div>
        {
          env.MINT_HEADER ?
          (

            <div className="w-gull py-2 mb-5 text-center uppercase heading-display border-b-[1px] border-[#404040]">
              THINK GENESIS MINT ON MAGIC EDEN <a className="underline" href={nftMintLink} target="_blank">NOW LIVE &#10132;</a>
            </div>
          ) : null
        }
        <div className="w-full px-4 lg:px-8 xl:px-10 2xl:px-16 3xl:px-24 py-2 lg:py-4">
          <div className="mx-auto flex w-full items-center justify-between gap-4 md:gap-4 lg:gap-6 xl:gap-12">
            <NavLink to="/" className="block transition hover:bg-gradient-to-b bg-clip-text hover:from-teal hover:to-sand hover:text-black hover:animate-logoGlow hover:animate-pulse hover:animate-infinite mask-logo">
              <h1 className="font-token uppercase text-2xl lg:text-3xl xl:text-6xl bg-gradient-to-b from-teal to-sand bg-clip-text text-transparent lg:col-span-3 place-self-center">Think</h1>
            </NavLink>
            <nav data-controller="menu" className="hidden lg:flex justify-items-start place-content-start text-offWhite gap-x-4 md:gap-x-6 lg:gap-x-8 md:text-xs lg:text-sm md:font-semibold md:leading-6 grow">
              <MainNavComponentItem to="/about" title="Team">Team</MainNavComponentItem>
              <MainNavComponentItem to="https://docs.thinkagents.ai" target="_blank" title="Docs">Docs</MainNavComponentItem>
              {/* <MainNavComponentItem to="/blog" title="News">News</MainNavComponentItem> */}
              <MainNavComponentItem to="/faq" title="FAQ">FAQ</MainNavComponentItem>
              <MainNavComponentItem to="/contact" title="Contact">Contact</MainNavComponentItem>
            </nav>
            <div className="hidden lg:block">
              <WalletButton className="px-6 py-5 ring ring-1 ring-inset ring-teal hover:bg-gradient-to-b text-white " />
            </div>
          </div>
        </div>
        <div id="navigation_groups" className="w-full absolute z-30 bg-black">
        </div>
        <div id="nav-scrim" className="absolute w-full h-full bg-black-950/50 backdrop-blur-sm z-20 hidden"></div>
      </div>
    </header>
  );
});
Header.displayName = "Header";

export { Header };